import { Box } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';
import { useGetCompany } from '../../hooks/useCompany';
import CompanyHeader from './components/companyDetail/CompanyHeader';
import CompanyInformation from './components/companyDetail/CompanyInformation';
import HistoryTable from './components/companyDetail/HistoryTable';

const AdminCompanyDetailPage = () => {
  const { id } = useParams();
  const { data } = useGetCompany({ id });

  return (
    <>
      <Helmet>
        <title>ประวัติการใช้งาน | Caltex StarCard</title>
      </Helmet>

      <Box>
        <Box
          component="section"
          maxWidth="lg"
          mx="auto"
          sx={{ padding: '2rem 1.25rem 6rem', position: 'relative' }}
        >
          {/* Company Hader */}
          <CompanyHeader />
          {/* Company information */}
          <CompanyInformation data={data?.Data.data[0] || {}} />
          {/* History table */}
          <HistoryTable data={data?.Data.data[0] || {}} />
        </Box>
      </Box>
    </>
  );
};

export default AdminCompanyDetailPage;
